var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCxMissingCert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9743 55.0001C18.2047 52.5505 12.8607 47.125 10.5237 40.3018",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5569 40.5649C53.1734 47.2643 47.8789 52.5846 41.1951 55.0011",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2102 10.1484C47.9746 12.599 53.3134 18.0235 55.6494 24.8426",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5237 24.8426C12.8586 18.0235 18.1985 12.599 24.9619 10.1484",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7922 8.72852C40.7922 12.9969 37.3321 16.457 33.0637 16.457C28.7953 16.457 25.3352 12.9969 25.3352 8.72852C25.3352 4.46013 28.7953 1 33.0637 1C37.3321 1 40.7922 4.46013 40.7922 8.72852Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8147 56.4155C40.8147 60.6839 37.3546 64.144 33.0862 64.144C28.8178 64.144 25.3577 60.6839 25.3577 56.4155C25.3577 52.1471 28.8178 48.687 33.0862 48.687C37.3546 48.687 40.8147 52.1471 40.8147 56.4155Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9714 32.5723C16.9714 36.8407 13.5113 40.3008 9.24292 40.3008C4.97453 40.3008 1.5144 36.8407 1.5144 32.5723C1.5144 28.3039 4.97453 24.8438 9.24292 24.8438C13.5113 24.8438 16.9714 28.3039 16.9714 32.5723Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6618 40.1971C51.9963 39.5922 49.2009 36.4087 49.2009 32.5718C49.2009 28.3034 52.6611 24.8433 56.9294 24.8433C61.1978 24.8433 64.658 28.3034 64.658 32.5718C64.658 36.8402 61.1978 40.3003 56.9294 40.3003C56.498 40.3003 56.0747 40.2652 55.6618 40.1971Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3193 8.35532C35.3193 9.60332 34.3077 10.6149 33.0597 10.6149C31.8117 10.6149 30.8 9.60332 30.8 8.35532C30.8 7.10732 31.8117 6.0957 33.0597 6.0957C34.3077 6.0957 35.3193 7.10732 35.3193 8.35532Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.929 14.7288C29.0621 12.5642 30.8603 10.8496 33.059 10.8496C35.3455 10.8496 37.1984 12.7025 37.1984 14.9879",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4985 32.1986C11.4985 33.4466 10.4869 34.4582 9.23886 34.4582C7.99086 34.4582 6.97925 33.4466 6.97925 32.1986C6.97925 30.9506 7.99086 29.939 9.23886 29.939C10.4869 29.939 11.4985 30.9506 11.4985 32.1986Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10815 38.5726C5.24235 36.4079 7.03951 34.6934 9.23822 34.6934C11.5247 34.6934 13.3776 36.5463 13.3776 38.8317",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3193 56.0423C35.3193 57.2903 34.3077 58.3019 33.0597 58.3019C31.8117 58.3019 30.8 57.2903 30.8 56.0423C30.8 54.7943 31.8117 53.7827 33.0597 53.7827C34.3077 53.7827 35.3193 54.7943 35.3193 56.0423Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.929 62.4158C29.0621 60.2512 30.8603 58.5366 33.059 58.5366C35.3455 58.5366 37.1984 60.3895 37.1984 62.6749",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1855 32.1986C59.1855 33.4466 58.1739 34.4582 56.9259 34.4582C55.6779 34.4582 54.6663 33.4466 54.6663 32.1986C54.6663 30.9506 55.6779 29.939 56.9259 29.939C58.1739 29.939 59.1855 30.9506 59.1855 32.1986Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7952 38.5726C52.9283 36.4079 54.7265 34.6934 56.9252 34.6934C59.2117 34.6934 61.0636 36.5463 61.0636 38.8317",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7179 21.3262L37.8202 30.1631L42.9214 39L32.7178 39L22.5144 39L27.6156 30.1631L32.7179 21.3262Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7179 28.8683L32.7179 31.4554",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7179 35.3333L32.7179 34.8549",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxMissingCert);
export default __webpack_public_path__ + "static/media/cx_missing_cert.df3631c757874e2d384297de597e5580.svg";
export { ForwardRef as ReactComponent };